import * as React from 'react';
import { useEffect } from 'react';
import { consentConfig } from './constants';
import ReactGA from 'react-ga4';
import { hashStringWithSHA256, isTesterEmail } from './utils';
import { useAppData } from '@/zustand/useAppData';

interface GoogleTagManagerSetterProps {
  consentGiven: boolean;
}

export const GoogleTagManagerSetter: React.FC<GoogleTagManagerSetterProps> = ({
  consentGiven
}) => {
  const { email, name } = useAppData((store) => store.appData);

  const stabilizedEmail = email.replace(/[ .]/g, '');

  useEffect(() => {
    if (consentGiven) {
      ReactGA.gtag('consent', 'default', consentConfig);

      ReactGA.initialize(process.env.REACT_APP_GTAG_ID);
      ReactGA.set({
        user_id: hashStringWithSHA256(stabilizedEmail),
        brand_name: name
      });

      ReactGA.event('logged_in');

      if (isTesterEmail(email)) {
        ReactGA.set({
          tester: true
        });
      }
    }
  }, [consentGiven]);

  return null;
};
